var bookshelf = require("../index-extended");
require("./Meeting");
require("./BuildingLot");
require("./BuildingOwner");
require("./Contact");
require("./VotingCategory");
require("./Media");

module.exports = bookshelf.model("Building", {
  entityName: "Building",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "building",
  meetings() {
    return this.hasMany("Meeting", "building_id");
  },
  building_owners() {
    return this.hasMany("BuildingOwner", "building_id");
  },
  contacts() {
    return this.hasMany("Contact", "building_id");
  },
  building_lots() {
    return this.hasMany("BuildingLot", "building_id");
  },
  voting_categories() {
    return this.hasMany("VotingCategory", "building_id");
  },
  media() {
    return this.belongsTo("Media"); // ???: ...
  },

  parse(res) {
    if (res.majority_conditions) res.majority_conditions = JSON.parse(res.majority_conditions);
    return res;
  },
  format(attrs) {
    if (attrs.majority_conditions)
      attrs.majority_conditions = JSON.stringify(attrs.majority_conditions);

    delete attrs["$id"];
    delete attrs["building_owners"];
    delete attrs["contacts"];
    delete attrs["building_lots"];
    delete attrs["meetings"];
    // TODO: ???: ...
    delete attrs["media"];

    return attrs;
  },
});
